__turbopack_context__.v({
  "icon": "kSgDqW_icon",
  "wrapper": "kSgDqW_wrapper",
  "wrapper--masked": "kSgDqW_wrapper--masked",
});
